import { ConsumersOverviewType } from "@/types/"
import { TypeSubmitGroup, TypeSubmitIndividual } from "@/types/announcement"
import { ConsumerStatsOverviewType } from "@/types/meter"

import { apiFetch, formatDate } from "../utils"

const billingUrl = `himo-billing/`
export async function getEmailListDropdown() {
  const response = await apiFetch(`${billingUrl}announcements/email-lists/`)

  if (!response.ok) {
    throw new Error("Cannot fetch email list dropdown")
  }

  return response.json()
}

export async function sendAnnouncment(
  data: TypeSubmitIndividual | TypeSubmitGroup,
) {
  const response = await apiFetch(`${billingUrl}email-blast/announcements`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    throw new Error("Cannot send Individual announcement")
  }

  return response.json()
}

export async function getConsumersOverview(
  days: number,
): Promise<ConsumersOverviewType> {
  const response = await apiFetch(
    `${billingUrl}consumers-overview/?days=${days}`,
  )

  if (!response.ok) {
    throw new Error("Cannot get consumers overview")
  }

  return response.json()
}

export async function getConsumersStatusOverview(
  days: number,
): Promise<ConsumerStatsOverviewType> {
  const response = await apiFetch(
    `${billingUrl}consumers-status-overview/?days=${days}`,
  )

  if (!response.ok) {
    throw new Error("Cannot get consumers status overview")
  }

  return response.json()
}

export async function getConsumersDailyAnalyticsCount(
  fromDate: string | Date,
  toDate: string | Date,
) {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)

  const response = await apiFetch(
    `${billingUrl}analytics/consumer-daily-count/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const jsonResponse = await response.json()
  return jsonResponse.consumer_daily_count
}

export async function getConsumersAnalyticsPieChart(
  fromDate: string | Date,
  toDate: string | Date,
) {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)

  const response = await apiFetch(
    `${billingUrl}analytics/consumer-piechart/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const jsonResponse = await response.json()
  return jsonResponse.consumer_status_distribution
}

export async function getConsumerBillPieAnalytics(
  fromDate: string | Date,
  toDate: string | Date,
) {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)

  const response = await apiFetch(
    `${billingUrl}consumer-bill/analytics/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    if (response.status === 404) {
      return {}
    }
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const jsonResponse = await response.json()
  return jsonResponse
}

export async function getBillingDailyCount(
  fromDate: string | Date,
  toDate: string | Date,
) {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)

  const response = await apiFetch(
    `${billingUrl}consumer-bill/daily-count/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    if (response.status === 404) {
      return {}
    }
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const jsonResponse = await response.json()
  return jsonResponse
}
